import * as Yup from 'yup';
import { Button, Col, Row } from "react-bootstrap-v5";
import { MInput } from "../../../components/MInput/MInput";
import { pesquisacep } from "../../services/ViaCep";
import { validar } from "../../services/Validacoes";
import { useEffect, useRef, useState } from "react";
import { API_URL } from "../../../components/MConfig";
import { getAxios } from "../../../components/net";
import { ValidateForm, convertFileToBase64, corColunaStatus, fire, getInput, removerAcentos, setInputValue, stringToData, toData, toFormValues, waitForElement } from "../../../../util";
import Swal from "sweetalert2";
import { MModal } from "../../../components/MModal/MModal";
import { AnexosProposta } from './AnexosProposta';
import { HistoricoProposta } from './HistoricoProposta';
import { listaEstados, tipoEstadoCivil, tipoPagamentoEnum } from '../tipos/tiposJs';
import { FromFormReference } from '../../../components/MForm/MForm';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { enviarMensagemServidor } from '../../../../setup/websocket';


export const PropostaCadastro = props => {
    const modal = useRef();
    const modalReuso = useRef();
    const urlOrgao = API_URL + "/cadastrosdb/GetOrgaoSiape";
    const [orgao, setOrgao] = useState(0);
    const [tipoPagamento, setTipoPagamento] = useState(0);
    const [opcaoSelecao, setOpcaoSelecao] = useState([]);
    const [produto, setProduto] = useState(0);
    const [anexos, setarAnexos] = useState([]);
    const [dados, setDados] = useState([]);
    const [visualizar, setVisualizar] = useState(false);
    const [usuario, setUsuario] = useState();
    const [VendedorUsuarioId, setUsuarioId] = useState();
    const [RevendedorId, setVendedorId] = useState();
    const [propostaAtual, setProposta] = useState();
    const [resultadoConsulta, setResultadoConsulta] = useState();
    const [ultimaConsulta, setUltimaConsulta] = useState(null);
    const [ultimaConsultaCpfl, setUltimaConsultaCpfl] = useState(null);



    // Variáveis constantes
    const StatusId = 1;
    const CodEmpresa = 1;

    var formRef = useRef();
    var modalSelecaoMatricula = useRef();

    const normalizaTelefone = e => {
        var tam = validar.clearMask(e.target.value)?.length ?? 0;
        e.target.value = validar.mask(e.target.value, (tam == 10 ? "(99)9999-9999" : "(99)99999-9999"));
    };

    const pesquisacepproposta = e => {
        e = validar.mask(e, '99999-999');
        pesquisacep(e);
    };

    const recarregarProposta = () => {
        const sticky = snapshotSticky();
        carregarProposta(dados);
        setTimeout(() => restoreSticky(sticky), 300);
    };

    const isProdutoEspecial = e => {
        return isUnaRh(e) || isAAspa(e);
    };

    const isUnaRh = e => {
        return e == 7;
    };

    const isAAspa = e => {
        return e == 6 || e == 9 || e == 10;
    };

    const isKompGroup = e => {
        return e == 1 || e == 2 || e == 3 || e == 4 || e == 5 || e == 8 || e == 13 || e == 16 || e == 17 || e == 18;
    };

    const isComaerGroup = e => {
        return e == 11 || e == 12;
    };

    const isCPFLGroup = e => {
        return e == 11 || e == 12;
    };

    const isNotKompMedicamentos = e => {
        return e !== 8;
    };
    const gerarUrlGeolocalizacao = (latitude, longitude) => {
        return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    };

    const resetFormulario = cpf => {
        const emptyData = {
            NomeCliente: '',
            EstadoCivil: '',
            Cpf: validar.mask(cpf, "999.999.999-99"),
            Sexo: '',
            NomeMae: '',
            Email: '',
            Telefone: '',
            Logradouro: '',
            Bairro: '',
            Cep: '',
            Cidade: '',
            Uf: '',
            Complemento: '',
            EndNumero: '',
            DataNascimento: null,
            Matricula: '',
            InstituidorMatricula: '',
            Orgao: '',
            CodigoOrgao: '',
            DocIdentidade: '',
            DocIdentidadeUf: '',
            DocIdentidadeOrgEmissor: '',
            docIdentidadeDataEmissao: null,

        };
        toFormValues(formRef, emptyData);
    };

    const preencheFormulario = (data) => {
        const d = { ...data };

        // normalizações já existentes
        if ((d.tipoPagamentoId ?? d.tipoPagamento) == tipoPagamentoEnum.DescontoContaLuz) {
            carregarIdentificadores(d); // popula instalacao, pn, titular_*
        }

        d.dataNascimento = toData(d.dataNascimento);
        d.docIdentidadeDataEmissao = toData(d.docIdentidadeDataEmissao);
        d.sexo = d?.sexo == "F" || d?.sexo == "2" || d?.sexo == "Feminino" ? "Feminino" : "Masculino";
        d.cpf = validar.mask(d.cpf, "999.999.999-99");
        d.uf = d.uf ?? d.Uf ?? '';
        d.uf_text = d.uf;
        d.orgao_text = d.orgao;
        d.orgao = d.codigoOrgao;
        d.instituidorMatricula = d.instituidorMatricula;

        setOrgao(d.codigoOrgao);
        setarAnexos(d.propostaAnexos);

        // preenche o form primeiro
        toFormValues(formRef, d);

        // se for “Desconto Conta Luz”, abre o bloco e garante os campos
        const tipoPag = d.tipoPagamentoId ?? d.tipoPagamento;
        if (Number(tipoPag) === Number(tipoPagamentoEnum.DescontoContaLuz)) {
            setTipoPagamento(Number(tipoPag));

            if (d.titular_cpf) {
                titularCpfRef.current = d.titular_cpf;
            }
            
            // espera os inputs existirem e coloca os valores (sem quebrar nada existente)
            setTimeout(() => {
                const cpfAtual = getInput('cpf')?.value || '';
                const nomeAtual = getInput('nomeCliente')?.value || '';

                waitForElement('titular_cpf', () => setInputValue('titular_cpf', d.titular_cpf ?? getInput('titular_cpf')?.value ?? cpfAtual));
                waitForElement('titular_nome', () => setInputValue('titular_nome', d.titular_nome ?? getInput('titular_nome')?.value ?? nomeAtual));
                waitForElement('instalacao', () => setInputValue('instalacao', d.instalacao ?? getInput('instalacao')?.value ?? ''));
                waitForElement('pn', () => setInputValue('pn', d.pn ?? getInput('pn')?.value ?? ''));
                waitForElement('pixData', () => setInputValue('pixData', d.pn ?? getInput('pixData')?.value ?? ''));
            }, 0);
        } else {
            // mantém comportamento padrão quando não é energia
            setTipoPagamento(Number(tipoPag || 0));
        }
    };


    function identifyAndDecodeBase64(base64String) {
        try {
            let decodedString = atob(base64String);
            return decodedString;
        } catch (e) {
            console.error("Erro ao decodificar a string base64: ", e);
            return null;
        }
    }

    const visualizarAnexo = (idx, historico = false) => {
        var url = API_URL + '/proposta/BuscarAnexo/' + idx;
        if (historico) url = API_URL + '/proposta/BuscarAnexoHistorico/' + idx;

        window.showWait(true);
        getAxios().get(url).then(res => {
            let e = res.data;
            if (e) {
                let base64;
                if (typeof e !== "string") {
                    console.error("Formato de imagem não suportado");
                    window.showWait(false);
                    return;
                }

                if (e.startsWith('aVZCT1J') || e.startsWith('LzlqLzR')) {
                    base64 = identifyAndDecodeBase64(e);
                } else {
                    base64 = e;
                }

                if (base64.startsWith('/9j/')) {
                    base64 = 'data:image/jpeg;base64,' + base64;
                } else if (base64.startsWith('iVBORw0KGgo')) {
                    base64 = 'data:image/png;base64,' + base64;
                } else if (base64.startsWith('R0lGODlh') || base64.startsWith('R0lGODdh')) {
                    base64 = 'image/gif' + base64;
                } else if (base64.startsWith('aVZCT1J')) {
                    base64 = 'data:image/png;base64,' + identifyAndDecodeBase64(base64);
                } else if (base64.startsWith('UklGR')) {
                    base64 = 'image/webp' + base64;
                } else {
                    console.error("Formato de imagem não suportado");
                    window.showWait(false);
                    return;
                }

                waitForElement('viewImage', () => {
                    document.getElementById('viewImage').setAttribute('src', base64);
                });
                modal.current.Show();
                window.showWait(false);
            }
        }).catch(e => {
            window.showWait(false);
        });
    };

    const preencherTelaCadastro = dadosPreencher => {
        if (dadosPreencher == undefined) return;
        dadosPreencher.estadoCivil = "Solteiro";
        if (dadosPreencher.cep)
            dadosPreencher.cep = validar.mask(dadosPreencher.cep, '99999-999');
        preencheFormulario(dadosPreencher);
    }

    const validarCpf = e => {
        var res = validar.inputCpf(e);

        if (res) {
            let convenio = props.edit.produtoId;
            let v = e.target.value;
            const CONSULTA_URL = `${API_URL}/Cpf/BuscarDadosPorCpf?cpf=${v}&tipo=${convenio}`;

            isProdutoEspecial(convenio) && window.showWait(true);
            getAxios().get(CONSULTA_URL).then(res => {
                if (res != null) {
                    var cadastros = res.data.cadastros;
                    var proposta = res.data.proposta;

                    if (proposta != null) {
                        proposta.id = 0;
                        setProposta(proposta);
                        setResultadoConsulta(res.data);
                        modalReuso.current.Show();
                        return true;
                    }

                    if (cadastros == null) {
                        resetFormulario(v);
                        isProdutoEspecial(convenio) && Swal.fire("ATENCAO!", "Nao foi encontrado nenhum cadastro para o cpf informado!", "warning");
                        return;
                    } else if (cadastros?.length > 1 && isProdutoEspecial(convenio)) {
                        setOpcaoSelecao(cadastros);
                        return;
                    }
                    preencherTelaCadastro(cadastros[0]);
                }
                return true;
            }).catch(res => {
                debugger;
                console.log(res);
                if (res.response) {
                    if (res.response.status === 404) {
                        resetFormulario(v);
                        var msg = res.response.data ?? "No momento este cliente não está Apto para adquirir este produto!";
                        Swal.fire("ATENCAO!", msg, "warning");
                    } else {
                        Swal.fire("Erro!", "Ocorreu um erro ao processar a solicitação!", "error");
                    }
                } else if (res.request) {
                    Swal.fire("Erro!", "Nenhuma resposta recebida do servidor!", "error");
                } else {
                    Swal.fire("Erro!", "Erro ao configurar a solicitação!", "error");
                }

                return false;
            }).finally(() => {
                window.showWait(false);
            });

        } else if (res == false) {
            window.showWait(false);
            window.modalAlert.Show({ title: "Atencao!", message: "Cpf inválido!", type: "error" });
            return false;
        }
    };

    const getMatriculaComaerValue = () =>
        document.getElementById('matriculaComaer')?.value ||
        document.querySelector('input[name="matricula"]')?.value || '';


    const validarCpfMatriculaComaer = e => {

        var res = validar.inputCpf(e);
        if (res) {

            let convenio = props?.edit?.produtoId ?? props.produtoId;
            let cpf = e.target.value; // CPF vindo do event (real ou sintético)
            const matricula = getMatriculaComaerValue(); // <<< NOVO: lê matrícula COMAER

            if (ultimaConsulta != null
                && ultimaConsulta?.matricula == matricula
                && ultimaConsulta?.cpf == cpf) return;

            setUltimaConsulta({ matricula, cpf });

            const CONSULTA_URL =
                `${API_URL}/Cpf/BuscarDadosPorCpfMatricula?cpf=${cpf}&matricula=${encodeURIComponent(matricula)}&tipo=${convenio}`;

            isComaerGroup(convenio) && window.showWait(true);

            getAxios().get(CONSULTA_URL).then(res => {
                return true;
            }).catch(res => {
                if (res.response) {
                    if (res.response.status === 404) {
                        /* resetFormulario(cpf); */
                        var msg = res.response.data ?? "No momento este cliente não tem margem!";
                        Swal.fire("ATENCAO!", msg, "warning");
                    } else {
                        Swal.fire("Erro!", "Ocorreu um erro ao processar a solicitação!", "error");
                    }
                } else if (res.request) {
                    Swal.fire("Erro!", "Nenhuma resposta recebida do servidor!", "error");
                } else {
                    Swal.fire("Erro!", "Erro ao configurar a solicitação!", "error");
                }
                return false;
            }).finally(() => {
                window.showWait(false);
            });

        } else if (res === false) {
            window.showWait(false);
            window.modalAlert.Show({ title: "Atencao!", message: "Cpf inválido!", type: "error" });
            return false;
        }
    };



    const buscarInstalacaoCpfl = e => {
        const instalacao = e.target.value;
        const cpf = getInput('titular_cpf')?.value || '';

        if (!instalacao) return;

        if (!cpf) {
            Swal.fire("Erro!", "Informe o CPF do titular da instalação!", "error");
            return;
        }

        if (ultimaConsultaCpfl?.instalacao === instalacao) return;
        setUltimaConsultaCpfl({ instalacao });

        const CONSULTA_URL = `${API_URL}/Cpf/BuscarDadosPorInstalacao?cpf=${cpf}&instalacao=${instalacao}`;

        window.showWait(true);
        getAxios().get(CONSULTA_URL).then(res => {
            setInputValue('pn', res.data.pn ?? '');
            return true;
        }).catch(res => {
            setInputValue('pn', '');
            if (res.response) {
                if (res.response.status === 404) {
                    const msg = res.response.data ?? "No momento este cliente não possui instalação cadastrada";
                    Swal.fire("ATENCAO!", msg, "warning");
                } else {
                    Swal.fire("Erro!", "Ocorreu um erro ao processar a solicitação!", "error");
                }
            } else if (res.request) {
                Swal.fire("Erro!", "Nenhuma resposta recebida do servidor!", "error");
            } else {
                Swal.fire("Erro!", "Erro ao configurar a solicitação!", "error");
            }
            return false;
        }).finally(() => {
            window.showWait(false);
        });
    };

    const showPainelSelecaoOpcaoMatricula = () => {
        preencheFormulario(opcaoSelecao[0]);
        modalSelecaoMatricula.current.Show();
    };

    useEffect(() => {
        if (opcaoSelecao.length > 0)
            showPainelSelecaoOpcaoMatricula();
    }, [opcaoSelecao]);

    useEffect(() => {
        ouvirPropostaOnline();
    }, []);


    const ouvirPropostaOnline = () => {
        let ultimoOnline = {};
        setInterval(() => {
            if (formRef == null || formRef?.current == null) return;
            var eles = FromFormReference(formRef.current);
            if (eles != null && eles != ultimoOnline) {
                if (JSON.stringify(eles) != JSON.stringify(ultimoOnline) && eles?.cpf != null) {
                    ultimoOnline = eles;
                    var obj = { cpf: eles.cpf, nome: eles.nomeCliente }
                    enviarMensagemServidor(obj, 1);
                }
            }
        }, 5000);
    }



    const carregarProposta = e => {
        window.showWait(true);
        const form = formRef.current;

        // >>> NOVO: salva os campos sensíveis antes do reset
        const sticky = snapshotSticky();

        form.reset();

        if (e.isEdit) {
            waitForElement('cpf', el => {
                el.setAttribute('disabled', 'disabled');
                var els = document.querySelectorAll('#bloco_cadastro [name]');
                Array.from(els).map(x => x.setAttribute('disabled', 'disabled'));
            });
        }

        if (e == undefined || e?.id == undefined) {
            setProduto(props.produto);
            window.showWait(false);
            // >>> NOVO: restaura os colados mesmo quando não há e.id
            restoreSticky(sticky);
            return;
        }

        getAxios().get(API_URL + "/Proposta/" + e.id).then(res => {
            var data = { ...res.data };
            debugger;
            var prod = props.produtos.filter(x => x.id == data.produtoId);

            if (prod.length == 0) {
                Swal.fire("ATENCAO!", "Existe algum erro nesse cadastro!", "warning");
                props.irPaginaPrincipal();
                window.showWait(false);
                return;
            }

            data.uf_text = data.uf;
            setDados(data);

            var prd = prod[0];
            setProduto(prd);
            props.setProduto(prd);
            preencheFormulario(data);

            if (e.isView) {
                var elemetos = Array.from(formRef.current);
                elemetos.forEach(element => {
                    if (element.id != "btnCancelar" && !element.classList.contains('noLock'))
                        element.setAttribute('disabled', 'disabled');

                    if (element.id == "btnSalvar")
                        element.remove();

                    if (element.id == "btnAprovarAuditoria")
                        element.remove();
                });
            }

            window.showWait(false);
            var el = document.getElementById('cpf');
            el?.focus();

            restoreSticky(sticky);

        }).catch(ex => {
            window.showWait(false);
            restoreSticky(sticky);
        });
    };


    useEffect(() => {
        var usuario = JSON.parse(window.localStorage.getItem("cnf"))?.usuario;
        setVisualizar(false);
        carregarProposta({ ...props.edit });
        setUsuario(JSON.parse(window.localStorage.getItem("cnf")));
        if (usuario) {
            setUsuarioId(usuario.id);
            setVendedorId(usuario.RevendedorId);
        }
    }, [props.edit]);

    const selecionaOrgao = valor => {
        setOrgao(valor);
    };

    const selecionaTipoPagamento = (valueOrEvent) => {
        debugger;
        const valor = (typeof valueOrEvent === 'object')
            ? (valueOrEvent?.target?.value ?? valueOrEvent?.value ?? valueOrEvent?.eventKey)
            : valueOrEvent;

        setTipoPagamento(valor);

        if (valor == tipoPagamentoEnum.DescontoContaLuz) {
            const cpf = getInput('cpf')?.value || document.querySelector('input[name="cpf"]')?.value || '';
            const nome = getInput('nomeCliente')?.value || document.querySelector('#nomeCliente, input[name="nomeCliente"]')?.value || '';

            setTimeout(() => {
                waitForElement('titular_cpf', () => {
                    setInputValue('titular_cpf', cpf);
                    setInputValue('titular_nome', nome);
                });
            }, 0);
        }
    };

    const cancelar = e => {
        props.irPaginaPrincipal();
    };

    const aprovarAuditoria = () => {
        window.showWait(true);
        var URL = `${API_URL}/Proposta/AprovarAuditoria`;
        if (dados.id > 0) {
            const dataAprovacaoAuditoria = {
                usuarioId: JSON.parse(window.localStorage.getItem("cnf")).usuario.id,
                propostaId: dados.id
            };

            getAxios().post(URL, dataAprovacaoAuditoria).then(res => {
                window.showWait(false);
                Swal.fire("Sucesso!", res.data, "success");
                props.irPaginaPrincipal(true);
            }).catch(res => {
                console.log(res);
                window.showWait(false);
                Swal.fire("Erro!", "<ul>" + JSON.stringify(res.response.data).split("\\r\\n").map(x => "<li>" + x + "<li>").join('') + "</ul>");
            });
            window.showWait(true);
        }
    };

    const atualizar = () => {
        carregarProposta({ ...props.edit });
    };

    const identificador = (res, nome) => res.identificadores?.filter(x => x.nome == nome).at(0)?.valor;

    const carregarIdentificadores = res => {
        res.instalacao = identificador(res, "Instalacao");
        res.pn = identificador(res, "PN");
        res.titular_parentesco = identificador(res, "Titular_Parentesco");
        res.titular_nome = identificador(res, "Titular_Nome");
        res.titular_cpf = identificador(res, "Titular_Cpf");
        res.pixData = identificador(res, "pixData");

    }

    const salvar = () => {

        debugger;
        if (document.getElementById('btnSalvar').disabled)
            return;

        document.getElementById('btnSalvar').setAttribute('disabled', 'disabled');

        ValidateForm(formRef.current).then(ret => {
            if (ret.length > 0) return;

            window.showWait(true);
            var URL = `${API_URL}/Proposta`;
            var sessao = JSON.parse(window.localStorage.getItem("cnf"));

            var res = FromFormReference(formRef.current, true);

            if (res.docIdentidade) res.docIdentidade = res.docIdentidade + "";
            if (res.endNumero) res.endNumero = res.endNumero + "";
            if (res.cep) res.cep = res.cep + "";
            if (res.docIdentidadeDataEmissao == "") res.docIdentidadeDataEmissao = null;

            res.VendedorUsuarioId = sessao.usuario.id;
            res.ProdutoId = produto.id;
            res.RevendedorId = sessao.usuario.revendedorId;
            res.StatusId = StatusId;
            res.CodEmpresa = CodEmpresa;
            res.PropostaAnexos = anexos;
            res.dataNascimento = stringToData(res.dataNascimento);

            if (isProdutoEspecial(produto?.id ?? 0)) res.tipoPagamentoId = tipoPagamentoEnum.DescontoFolha;
            if (res.docIdentidadeDataEmissao) res.docIdentidadeDataEmissao = stringToData(res.docIdentidadeDataEmissao);

            if (res.sexo == undefined) {
                window.modalAlert.Show({ title: "Erro", message: "Sexo invalido!", type: "error" });
                return;
            }


            //INICIO: Tratamento de Identificador
            var identificadores = [];
            if (res.matricula) res.matricula = res.matricula + "";

            if (res.instituidorMatricula) {
                identificadores.push({ Nome: "Orgao", Valor: orgao + "" });
                identificadores.push({ Nome: "Instituidor", Valor: res.instituidorMatricula + "" });
            }

            if (res.tipoPagamentoId == tipoPagamentoEnum.DescontoContaLuz) {
                identificadores.push({ Nome: "Instalacao", Valor: res.instalacao + "" });
                identificadores.push({ Nome: "PN", Valor: res.pn + "" });
                identificadores.push({ Nome: "Titular_Parentesco", Valor: res.titular_parentesco + "" });
                identificadores.push({ Nome: "Titular_Nome", Valor: res.titular_nome + "" });
                identificadores.push({ Nome: "Titular_Cpf", Valor: res.titular_cpf + "" });
            }

            if (res.tipoPagamentoId == tipoPagamentoEnum.PixRecorrente) {
                identificadores.push({ Nome: "PixData", Valor: res.pixData + "" });
            }

            res.Identificadores = identificadores;

            //FIM: Tratamento de Identificador

            const config = {
                headers: { Authorization: `Bearer ${sessao.token}`, userId: sessao.usuario.id }
            };

            if (dados.id > 0) {
                res.id = dados.id;
                getAxios().put(URL, res, config).then(res => {
                    window.showWait(false);
                    Swal.fire("Sucesso!", "Proposta atualizada com sucesso!", "success");
                    props.irPaginaPrincipal(true);
                }).catch(res => {
                    console.log(res);
                    window.showWait(false);
                    Swal.fire("Erro!", "<ul>" + JSON.stringify(res.response.data).split("\\r\\n").map(x => "<li>" + x + "<li>").join('') + "</ul>");
                })
            }
            else {
                getAxios().post(URL, res, config).then(res => {
                    window.showWait(false);
                    Swal.fire("Sucesso!", "Proposta cadastrada com sucesso!", "success");
                    props.irPaginaPrincipal(true);
                }).catch(res => {
                    console.log(res);
                    window.showWait(false);
                    Swal.fire("Erro!", "<ul>" + JSON.stringify(res.response.data).split("\\r\\n").map(x => "<li>" + x + "<li>").join('') + "</ul>");
                })
            }
        })
            .catch(() => document.getElementById('btnSalvar').removeAttribute('disabled'))
            .finally(() => document.getElementById('btnSalvar').removeAttribute('disabled'));
    };

    const validarData = e => {
        var valid = validar.isValidDate(e.target.value);
        if (!valid) window.modalAlert.Show({ title: "Atencao!", message: "Data de nascimento inválida!", type: "error" });
    };

    const tipoSexo = [{ value: "Masculino", text: "Masculino" }, { value: "Feminino", text: "Feminino" }, { value: "Outro", text: "Outro" }];

    const selecionaMatricula = e => {
        preencheFormulario(e);
        setTimeout(() => {
            waitForElement("nomeCliente", el => {
                el.focus();
            });
        }, 200);
    };

    const schema = Yup.object().shape({
        emailPessoal: Yup.string().email('Email inválido'),
        emailCorporativo: Yup.string().email('Email inválido'),
    });

    const { control, handleSubmit, formState: { errors }, trigger } = useForm({
        resolver: yupResolver(schema),
    });

    const onSubmit = data => {
        console.log(data);
        salvar();
        return false;
    };

    const handleUfSelect = (valOrEvent) => {
        const value =
            typeof valOrEvent === 'string' || typeof valOrEvent === 'number'
                ? String(valOrEvent)
                : (valOrEvent?.target?.value ?? valOrEvent?.value ?? '');

        if (!value) return;

        // mantém estado (caso re-render)
        setDados(prev => ({ ...prev, uf: value }));

        // garante existir um input com esse valor para o FromFormReference
        setInputValue('uf', value);
        setInputValue('uf_text', value); // muitos selectSearch usam *_text para exibição
    };

    const validarProdutoAcessoAnexos = () => {
        carregarProposta({ ...props.edit });
    };

    const reutilizar = () => {
        preencheFormulario(propostaAtual);
        modalReuso.current.Close();
    }

    const naoReutilizar = () => {

        var cadastros = resultadoConsulta?.cadastros;
        let convenio = props.edit.produtoId;
        if (resultadoConsulta?.cadastros.length == 0) return;
        if (cadastros?.length > 1 && isProdutoEspecial(convenio))
            setOpcaoSelecao(cadastros);

        preencherTelaCadastro(cadastros[0]);
    }

    //Helpers nos campos
    const stickyKeysRef = useRef([
        'instalacao',
        'pn',
        'titular_parentesco',
        'titular_nome',
        'titular_cpf',
        'tipoPagamentoId',
    ]);

    const snapshotSticky = () => {
        if (!formRef?.current) return {};
        const current = FromFormReference(formRef.current) || {};
        const snap = {};
        stickyKeysRef.current.forEach(k => {
            let v = current?.[k];
            if (v === undefined || v === null || v === '') {
                v = getInput(k)?.value;
            }
            if (k === 'titular_cpf' && (!v || v === '')) {
                v = titularCpfRef.current || v;
            }
            if (v !== undefined && v !== null && v !== '') {
                snap[k] = v;
            }
        });
        return snap;
    };


    const restoreSticky = (snap) => {
        if (!snap) return;

        const aplicar = () => {
            // reabre o bloco se for energia
            if (Number(snap.tipoPagamentoId) === Number(tipoPagamentoEnum.DescontoContaLuz)) {
                setTipoPagamento(Number(snap.tipoPagamentoId));
            }

            waitForElement('titular_cpf', () => {
                const cpfAtual = getInput('cpf')?.value || '';
                const valor = titularCpfRef.current || snap.titular_cpf || getInput('titular_cpf')?.value || cpfAtual;
                setInputValue('titular_cpf', valor);
                titularCpfRef.current = valor;
            });

            waitForElement('titular_nome', () => {
                const nomeAtual = getInput('nomeCliente')?.value || '';
                setInputValue('titular_nome', snap.titular_nome ?? getInput('titular_nome')?.value ?? nomeAtual);
            });
            waitForElement('instalacao', () => {
                setInputValue('instalacao', snap.instalacao ?? getInput('instalacao')?.value ?? '');
            });
            waitForElement('pn', () => {
                setInputValue('pn', snap.pn ?? getInput('pn')?.value ?? '');
            });
        };

        setTimeout(aplicar, 0);
    };


    const titularCpfRef = useRef('');
    const onChangeTitularCpf = (e) => {
        titularCpfRef.current = e?.target?.value ?? '';
    };


    return (
        <>
            <MModal size={1.5} ref={modal} title="Seleção de Anexo" closeText="Fechar" >
                <Col className="col-12">
                    <img id="viewImage" style={{ width: "100%", height: "100%" }} />
                </Col>
            </MModal>

            <MModal size={1.5} ref={modalReuso} title="Reutilizar dados?" closeText="Não" saveText="Sim, Reutilizar" saveButton={true} onClickCancel={e => naoReutilizar()} onClickSave={e => reutilizar()} >
                <Col className="col-12">
                    <center>
                        <i class="fa fa-5x fa-database" aria-hidden="true"></i> <br />
                    </center> <br />
                    <p>Existe uma proposta já digitada no sistema para este CPF. <br /> Deseja utilizar os mesmos dados para esta nova proposta?</p>
                </Col>
            </MModal>

            <MModal size={2} ref={modalSelecaoMatricula} id="modalSelecaoMatricula" title="Selecione a matrícula desejada:" closeText="Cancelar"  >
                <Row>
                    <Col>
                        <strong>Nome: {opcaoSelecao.length > 0 ? opcaoSelecao[0].nomeCliente : ""}</strong>
                    </Col>
                </Row>
                <table className="table tableselect  mt-5">
                    <thead>
                        <tr>
                            <td>Matrícula</td>
                            {isUnaRh(produto.id) &&
                                <>
                                    <td>Instituidor</td>
                                    <td colSpan={2} >Órgão</td>
                                </>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            opcaoSelecao.map(e =>
                            (<tr onClick={() => selecionaMatricula(e)} data-bs-dismiss="modal">
                                <td>{e.matricula}</td>
                                {isUnaRh(produto.id) &&
                                    <>
                                        <td>{e.instituidorMatricula}</td>
                                        <td>{e.codigoOrgao}</td>
                                        <td>{e.orgao}</td>
                                    </>}
                            </tr>)
                            )
                        }
                    </tbody>
                </table>
            </MModal>

            <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                <div id="bloco_cadastro">
                    <Row>
                        <Col className='col-3'>
                            {dados.id > 0 &&
                                <div id="codigoProposta">CÓDIGO DA PROPOSTA: <b>{dados.id}</b></div>
                            }
                        </Col>
                        <Col className='col-9'  >
                            {dados.id > 0 &&
                                <table className='tbStatus'>
                                    <tr>
                                        <td colSpan={2} >STATUS DA PROPOSTA:</td>
                                    </tr>
                                    <tr>
                                        <td id="nomeStatus"><b>{dados.nomeStatus?.toUpperCase()}</b> </td>
                                        <td><div className='bolinha' style={{ backgroundColor: corColunaStatus(dados.statusId) }} ></div> </td>
                                    </tr>
                                </table>
                            }
                        </Col>
                    </Row>
                    <hr />
                    <Row>
                        <Col className='col-8 col-md-2'>
                            <MInput
                                type="mask"
                                name="cpf"
                                mask="999.999.999-99"
                                title="Cpf"
                                validate={e => e.string().required('Campo Cpf obrigatorio!').test('validacpf', 'Cpf invalido!', validar.cpf)}
                                onBlur={e => {
                                    if (!isComaerGroup(produto.id)) {
                                        validarCpf(e); // regra antiga preservada
                                    }
                                }}
                            />
                        </Col>
                        {isComaerGroup(produto.id) && (
                            <Col className="col-12 col-md-2">
                                <MInput
                                    id="matriculaComaer"
                                    name="matricula"
                                    type="text"
                                    required
                                    title="Matrícula"
                                    onBlur={e => {
                                        const cpf = document.querySelector('input[name="cpf"]')?.value?.trim() || '';
                                        const matricula = e?.target?.value?.trim() || '';

                                        if (!cpf || !matricula) return; // só busca quando os dois tiverem valor

                                        // sua função espera um "event" com CPF em e.target.value → passamos um sintético
                                        validarCpfMatriculaComaer({ target: { value: cpf } });
                                    }}
                                />
                            </Col>
                        )}
                        <Col className="col-12 col-md-4">
                            <MInput id="nomeCliente" required type="text" title="Nome" />
                        </Col>
                        <Col className='col-6 col-md-2'>
                            <MInput type="select" id="estadoCivil" required data={tipoEstadoCivil} title="Estado Civil" />
                        </Col>
                        <Col className='col-6 col-md-2'>
                            <MInput type="select" id="sexo" data={tipoSexo} title="Sexo" />
                        </Col>
                        <Col className="col-md-2">
                            <MInput id="dataNascimento" type="mask" required mask="99/99/9999" title="Dt.Nascimento" onBlur={e => validarData(e)} value={dados.dataNascimento || ''} />
                        </Col>
                    </Row>
                    <Row>
                        {isProdutoEspecial(produto.id) &&
                            <Col className="col-12 col-md-2">
                                <MInput id="matricula" type="text" disabled={dados.id !== null ? "disabled" : ""} required title="Matrícula" />
                            </Col>
                        }
                        {isUnaRh(produto.id) &&
                            <>
                                <Col className="col-12 col-md-4">
                                    <MInput id="instituidorMatricula" type="text" title="Matrícula do Instituidor" />
                                </Col>
                                <Col className='col-12 col-md-6'>
                                    <MInput id="orgao"
                                        type="selectSearch"
                                        title="Orgao"
                                        required
                                        placeholder="Digite o nome ou código do órgão..."
                                        url={urlOrgao} params={v => ({ filtro: v })}
                                        onResult={res => res.map(z => ({ value: z.id, text: z.id + " - " + z.nome }))}
                                        onSelect={e => selecionaOrgao(e)}
                                    />
                                </Col>
                            </>}
                    </Row>
                    <hr />
                    <strong>IDENTIDADE</strong>
                    <Row>
                        {!isNotKompMedicamentos(produto.id) &&
                            <Col className="col-md-3 col-6">
                                <MInput id="docIdentidade" required type="text" title="Nº Identidade" />
                            </Col>
                        }
                        {isNotKompMedicamentos(produto.id) &&
                            <Col className="col-md-3 col-6">
                                <MInput id="docIdentidade" required type="text" title="Nº Identidade" />
                            </Col>
                        }

                        <Col className="col-md-3 col-6">
                            <MInput id="docIdentidadeUf" type="text" title="UF Identidade" maxLength="2" />
                        </Col>
                        <Col className="col-md-3 col-6">
                            <MInput id="docIdentidadeOrgEmissor" type="text" title="Órgão Emissor" />
                        </Col>
                        <Col className="col-md-3 col-6">
                            <MInput id="docIdentidadeDataEmissao" type="mask" mask="99/99/9999" title="Data Emissão" value={dados.docIdentidadeDataEmissao || ''} />
                        </Col>
                    </Row>
                    <hr />
                    <strong>DADOS GERAIS</strong>
                    <Row>
                        <Col className="col-md-2 col-6">
                            <MInput name="telefonePessoal" required type="mask" mask="(99)99999-9999" title="Telefone Celular" onBlur={e => normalizaTelefone(e)} />
                        </Col>
                        <Col className="col-md-2 col-6">
                            <MInput name="telefoneCorporativo" type="mask" mask="(99)99999-9999" title="Telefone Fixo" onBlur={e => normalizaTelefone(e)} />
                        </Col>
                        <Col className="col-md-8 col-12">
                            <MInput id="nomeMae" required type="text" title="Nome da Mãe" />
                        </Col>
                        <Col className="col-md-6 col-12">
                            <Controller
                                name="emailPessoal"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <div>
                                        <MInput
                                            id="emailPessoal"
                                            type="email"
                                            title="Email Pessoal"
                                            required
                                            {...field}
                                            onBlur={async e => {
                                                e = e?.currentTarget ?? e.target ?? e;
                                                e.value = removerAcentos(e.value);
                                                field.onBlur();
                                                await trigger('emailPessoal');
                                            }}
                                        />
                                        {errors.emailPessoal && (
                                            <span style={{ color: 'red' }}>{errors.emailPessoal.message}</span>
                                        )}
                                    </div>
                                )}
                            />
                        </Col>
                        <Col className="col-md-6 col-12">
                            <Controller
                                name="emailCorporativo"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <div>
                                        <MInput
                                            id="emailCorporativo"
                                            type="email"
                                            title="Email Corporativo"
                                            {...field}
                                            onBlur={async e => {
                                                e = e?.currentTarget ?? e.target ?? e;
                                                e.value = removerAcentos(e.value);
                                                field.onBlur();
                                                await trigger('emailCorporativo');
                                            }}
                                        />
                                        {errors.emailCorporativo && (
                                            <span style={{ color: 'red' }}>{errors.emailCorporativo.message}</span>
                                        )}
                                    </div>
                                )}
                            />
                        </Col>
                    </Row>
                    <hr />
                    <strong>ENDEREÇO</strong>
                    <Row>
                        <Col className='col-6 col-md-2' >
                            <MInput id="cep" required name="cep" type="mask" mask="99999-999" onFocus={e => console.log(e)} title="Cep" onBlur={e => pesquisacepproposta(e.target.value)} />
                        </Col>
                        <Col className='col-12 col-md-6'>
                            <MInput id="logradouro" required type="text" title="Logradouro" />
                        </Col>
                        <Col className='col-4 col-md-1'>
                            <MInput id="endNumero" required type="text" title="Número" />
                        </Col>
                        <Col className='col-8 col-md-3' >
                            <MInput id="complemento" type="text" title="Complemento" />
                        </Col>
                    </Row>
                    <Row>
                        <Col className='col-6 col-md-6' >
                            <MInput id="bairro" required type="text" title="Bairro" />
                        </Col>
                        <Col className='col-6 col-md-4' >
                            <MInput id="cidade" required name="cidade" type="text" title="Cidade" />
                        </Col>
                        <Col className='col-4 col-md-2' >
                            <MInput id="uf" data={listaEstados.map(x => ({ value: x, text: x }))} type="selectSearch" title="UF" onSelect={handleUfSelect} />
                        </Col>
                    </Row>
                    {!isProdutoEspecial(produto.id) && !isComaerGroup(produto.id) &&
                        <>
                            {isKompGroup(produto.id) && <Row>
                                <Col>
                                    <MInput type="select" id="tipoPagamentoId" name="tipoPagamentoId"
                                        url={API_URL + "/produto/ListarTipoPagamentoPorProdutoID/" + produto.id}
                                        onResult={item =>
                                            item                                                
                                                .map(x => ({ value: x.id, text: x.nome }))
                                        }
                                        onSelect={e => selecionaTipoPagamento(e)}
                                        onResultFinished={e => selecionaTipoPagamento(e)}
                                        title="Tipo de Pagamento" />
                                </Col>
                            </Row>}

                            {!isKompGroup(produto.id) && (
                                <Row>
                                    <Col>
                                        <MInput
                                            type="select"
                                            id="tipoPagamentoId"
                                            name="tipoPagamentoId"
                                            url={API_URL + "/proposta/ListarTiposPagamentos"}
                                            onResult={item =>
                                                item
                                                    ?.filter(x => x.id === 4)
                                                    .map(x => ({ value: x.id, text: x.nome }))
                                            }
                                            onSelect={e => selecionaTipoPagamento(e)}
                                            onResultFinished={e => selecionaTipoPagamento(e)}
                                            title="Tipo de Pagamento"
                                        />
                                    </Col>
                                </Row>
                            )}
                            {tipoPagamento == tipoPagamentoEnum.PixRecorrente &&
                                <>
                                <MInput id="pixData" type="mask" required mask="99/99/9999" title="Data 1º pagamento" onBlur={e => validarData(e)} value={dados.pixData || ''} />
                                </>
                            }
                            {tipoPagamento == tipoPagamentoEnum.DescontoContaLuz &&
                                <div style={{ display: (tipoPagamento == tipoPagamentoEnum.DescontoContaLuz ? "block" : "none") }}>
                                    <>
                                        <Row>
                                            <Col className='col-6 col-md-6' >
                                                <MInput
                                                    id="titular_cpf"
                                                    type="mask"
                                                    name="titular_cpf"
                                                    mask="999.999.999-99"
                                                    title="Cpf do Titular da instalação"
                                                    onChange={onChangeTitularCpf}
                                                    validate={e => e.string().required('Campo Cpf do titular da instalação é obrigatorio!').test('validacpf', 'Cpf invalido!', validar.cpf)}
                                                />
                                            </Col>
                                            <Col className='col-6 col-md-6' >
                                                <MInput id="instalacao" onBlur={e => buscarInstalacaoCpfl(e)} name="instalacao" required type="text" title="Nº Instalação" />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='col-6 col-md-6' >
                                                <MInput id="pn" name="pn" required type="text" title="Nº PN" />
                                            </Col>
                                            <Col className="col-6 col-md-6">
                                                <MInput
                                                    id="titular_parentesco"
                                                    name="titular_parentesco"
                                                    required
                                                    type="select"
                                                    title="Parentesco com Titular"
                                                    data={[
                                                        { value: "Titular", text: "Titular" },
                                                        { value: "PaiMãe", text: "Pai/Mãe" },
                                                        { value: "Cônjugue", text: "Cônjugue" }
                                                    ]}
                                                    placeholder="Selecione..."
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='col-12 col-md-12' >
                                                <MInput id="titular_nome" name="titular_nome" required type="text" title="Nome do Titular da Instalação" />
                                            </Col>
                                        </Row>
                                    </>
                                </div>
                            }
                        </>
                    }
                    {isComaerGroup(produto.id) &&
                        <Row>
                            <Col>
                                <MInput type="select" id="tipoPagamentoId"
                                    url={API_URL + "/proposta/ListarTiposPagamentos"}
                                    onResult={item =>
                                        item
                                            ?.filter(x => x.id !== 2 && x.id !== 3 && x.id !== 4) // Filtra os itens 2 e 3
                                            .map(x => ({ value: x.id, text: x.nome }))
                                    }
                                    title="Tipo de Pagamento" />
                            </Col>
                        </Row>
                    }
                    {(JSON.parse(window.localStorage.getItem("cnf")).perfilId > 10 || JSON.parse(window.localStorage.getItem("cnf")).usuario.revendedorId == 158) && dados.longitude && dados.latitude &&
                        <>
                            <hr />
                            <strong>GEOLOCALIZAÇÃO</strong>
                            <Row>
                                <Col className="col-12 col-md-4">
                                    <MInput data={dados.latitude} id="latitude" disabled type="text" title="Latitude" />
                                </Col>
                                <Col className="col-12 col-md-4">
                                    <MInput data={dados.longitude} id="longitude" disabled type="text" title="Longitude" />
                                </Col>
                                <Col className="col-12 col-md-4">
                                    <br /><br /> <br />
                                    <a
                                        href={gerarUrlGeolocalizacao(dados.latitude, dados.longitude)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        class="fas fa-map-marker-alt"
                                    >
                                        Abrir no Mapa
                                    </a>
                                </Col>
                            </Row>
                        </>
                    }
                </div>
                <hr /> {/*TODO Validar !isComaerGroup(produto.id) &&*/}
                {isNotKompMedicamentos(produto.id) &&
                    <AnexosProposta setarAnexos={setarAnexos} recarregarProposta={recarregarProposta} anexos={anexos} visualizarAnexo={visualizarAnexo} />
                }

                <hr />
                <HistoricoProposta dados={dados.propostaHistoricos} visualizarAnexo={visualizarAnexo} />

                <div style={{ height: 500 }}>
                </div>
                <Row>
                    <div style={{ height: "800px;" }}>
                        <br></br>
                    </div>
                </Row>
                <div className='footer'>
                    <table>
                        <tr>
                            <td>
                                {(() => {
                                    const cnf = JSON.parse(window.localStorage.getItem("cnf"));
                                    if (
                                        cnf &&
                                        (cnf.perfilId > 10 || cnf.usuario.revendedorId == 158) &&
                                        ((dados.statusId > 6 && dados.statusId <= 10) || (dados.statusId == 36 || dados.statusId == 25))
                                    ) {
                                        let textoBotao = "Aprovar Auditoria";

                                        if (dados.statusId === 25) {
                                            textoBotao = "Proposta integrada / Pendente Kompleto";
                                        } else if (dados.statusId === 36) {
                                            textoBotao = "Aguardando auditoria / Recusada CPFL";
                                        } else if (dados.statusId >= 7 && dados.statusId <= 10) {
                                            textoBotao = "Aprovar Auditoria";
                                        } else if (dados.statusId === 39) {
                                            textoBotao = "Aguardando auditoria / Ocorrência CPFL";
                                        }

                                        return (
                                            <Button
                                                className="btn-sm"
                                                title={textoBotao}
                                                id="btnAprovarAuditoria"
                                                style={{ backgroundColor: "green", color: "white" }}
                                                onClick={() => aprovarAuditoria()}
                                            >
                                                <i className="fa fa-edit"></i>
                                                {textoBotao}
                                            </Button>
                                        );
                                    }
                                    return null;
                                })()}
                            </td>
                            <td>
                                <Button className='btn-info btn-sm' id="btnSalvar" onClick={() => atualizar()} >
                                    <i className="fa fa-recycle"></i>
                                    Atualizar
                                </Button>
                            </td>
                            <td>
                                <Button className='btn-sm' id="btnSalvar" onClick={() => salvar()}>
                                    <i className="fa fa-save"></i>
                                    Salvar
                                </Button>
                            </td>
                            <td>
                                <Button id="btnCancelar" onClick={e => cancelar()} className="btn-secondary btn-sm">
                                    <i className="fa fa-sign-out" aria-hidden="true"></i>
                                    Fechar
                                </Button>
                            </td>
                        </tr>
                    </table>
                </div>
            </form>
        </>
    );
};
